import React from 'react';
import { OrbitControls, PerspectiveCamera } from '@react-three/drei';
import { Rack9slot } from './modelFunc/Orion_9slotrack';

/**
 * A reusable 3D module component that renders a 3D model at a specified position.
 * 
 * @param {object} props 
 * @param {array} props.position - The 3D position of the module [x, y, z]
 * @param {function} props.func - The function that returns the 3D model
 * @returns {ReactElement} A 3D module component
 * @example
 * <Module3D position={[10, 20, 30]} func={Rack9slot} />
 */
const Module3D = ({ position, func }) => {
  return (<>{func(position)}</>);
};

/**
 * A 3D view component that renders a collection of 3D modules and a rack model.
 * 
 * @param {object} props.selectedModules - An object containing the selected modules and rack model
 * @param {array} props.selectedModules.modules - An array of module objects with func properties
 * @param {function} props.selectedModules.rackModel - The function that returns the rack model
 * @returns {ReactElement} A 3D view component
 
 */

const Model3DView = ({ selectedModules }) => {
  return (
    <>
      <PerspectiveCamera makeDefault position={[122, 0, 600]} />
      <OrbitControls target={[122, 0, 0]} /*targets the middle of the rack */ />
      {selectedModules.modules && selectedModules.modules.map((module, index) => {
        return (
          <Module3D
            key={index}
            /*Using index to calculate the position because
            selectedModules has all the modules in the right order and in the right slot(index).
            30.5 is the width of every model */
            position={[30.5 * index +0.1,-8.8, 12.3]}
            func={module.func}/*module.func has the method to render the 3d model*/
          />
        );
      })}
      <mesh>
        {selectedModules.rackModel ? selectedModules.rackModel([0, 0, 0]) : Rack9slot([0, 0, 0]) /*Rack model. By default using 9 slot rack*/}
      </mesh>
      <directionalLight args={[0xffffff, 1.5]}  position={[0,0,1]} /*Light from above*//>
    </>
  );
};

export default Model3DView;